export default __webpack_public_path__ + "static/media/fwoptions.f2123ba3.png";